import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";

export class searchEndedEvent extends ClickEvent {
  source: String;
  query: String;
  language: String;
  result: Number;
  competitorsCount: Number;
  competitionsCount: Number;
  athletesCount: Number;
  entityType: Number;
  entityId: Number;

  constructor(params: searchEndedEvent) {
    super('', 'ended', 'search');

    this.source = params.source;
    this.query = params.query;
    this.language = params.language;
    this.result = params.result;
    this.competitorsCount = params.competitorsCount;
    this.competitionsCount = params.competitionsCount;
    this.athletesCount = params.athletesCount;
    this.entityType = params.entityType;
    this.entityId = params.entityId;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;
    properties.text = this.query;
    properties.language = this.language;
    properties.result = this.result;
    properties.numTeams = this.competitorsCount;
    properties.numLeagues = this.competitionsCount;
    properties.numAthletes = this.athletesCount;
    properties.entityType = this.entityType;
    properties.entityId = this.entityId;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();
    return new GoogleAnalyticsEventModel(eventName, {
      query: this.query
    })
  }
}
